import React from 'react';
import { MenuLeafNode } from './menu-nodes/MenuLeafNode';
import { MenuParentNode } from './menu-nodes/MenuParentNode';
import { I18nUtils } from '../../../../../../../i18n/I18nUtils';
import { PsRoutes } from '../../../../../routing/Routes';

export const SuperAdminMenu = () => {
    return (
        <React.Fragment>
            <MenuLeafNode
                icon={'home'}
                label={I18nUtils.tr('TR_INICIO')}
                route={PsRoutes.HOME}
                activeRoutes={[PsRoutes.HOME]}
            />
            <MenuParentNode
                icon={'account_box'}
                label={I18nUtils.tr('TR_USUARIOS')}
                activeRoutes={[
                    PsRoutes.USERS,
                    PsRoutes.USERS_ADD,
                    PsRoutes.USERS_DETAIL,
                ]}
            >
                <MenuLeafNode
                    label={I18nUtils.tr('TR_NUEVO_USUARIO')}
                    route={PsRoutes.USERS_ADD}
                    activeRoutes={[PsRoutes.USERS_ADD]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TODOS_LOS_USUARIOS')}
                    route={PsRoutes.USERS}
                    activeRoutes={[PsRoutes.USERS, PsRoutes.USERS_DETAIL]}
                />
            </MenuParentNode>
            <MenuParentNode
                icon={'work'}
                label={I18nUtils.tr('TR_MIS_CONTRATISTAS')}
                activeRoutes={[
                    PsRoutes.CONTRACTORS,
                    PsRoutes.CONTRACTORS_ADD,
                    PsRoutes.CONTRACTORS_EDIT,
                ]}
            >
                <MenuLeafNode
                    label={I18nUtils.tr('TR_NUEVO_CONTRATISTA')}
                    route={PsRoutes.CONTRACTORS_ADD}
                    activeRoutes={[PsRoutes.CONTRACTORS_ADD]}
                />
                <MenuLeafNode
                    label={I18nUtils.tr('TR_TODOS_LOS_CONTRATISTAS')}
                    route={PsRoutes.CONTRACTORS}
                    activeRoutes={[
                        PsRoutes.CONTRACTORS,
                        PsRoutes.CONTRACTORS_EDIT,
                    ]}
                />
            </MenuParentNode>
        </React.Fragment>
    );
};

SuperAdminMenu.propTypes = {};

SuperAdminMenu.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/menus-by-role/SuperAdminMenu.jsx